/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionOverview = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
    },
};